'use client'

import { useState } from 'react'
import type { Form as FormType } from '@payloadcms/plugin-form-builder/types'
import { Button } from '@/components/ui/button'
import { EnquiryModal, type EnquiryAgent } from './EnquiryModal'

export interface AgentAskButtonProps {
  /** e.g. "10 Fairweather Avenue, Suburbville" — modal header + enquiry subject */
  addressShort: string
  form: FormType | null
  agents: EnquiryAgent[]
  agentEmails: string[]
  /** FeedBridge listing_vertical, when the caller has one in scope — see
   *  EnquiryModal's `vertical` prop. Omitted call sites report as a buyer enquiry. */
  vertical?: string | null
}

/**
 * Sidebar staff-card "Ask a Question" pill. Opens the same EnquiryModal as the
 * property CTA buttons (intent "question") — previously a bare mailto: link
 * that bounced visitors into their mail client.
 */
export function AgentAskButton({
  addressShort,
  form,
  agents,
  agentEmails,
  vertical,
}: AgentAskButtonProps) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button type="button" variant="outline" size="mini" onClick={() => setOpen(true)}>
        Ask a Question
      </Button>
      <EnquiryModal
        open={open}
        intent="question"
        onClose={() => setOpen(false)}
        addressShort={addressShort}
        form={form}
        agents={agents}
        agentEmails={agentEmails}
        vertical={vertical}
      />
    </>
  )
}
